import React from "react"
import { useIntl } from "react-intl"
import { Title } from "#/services/page-title/Title"
import { LoadingInner } from "#/components/views/Loading"
import { CarrotErrorCodes } from "#/utils/CarrotErrors"

// The deep entry, not the package index: the index carries the subscription funnel and Stripe with
// it, and this page has no billing on it.
const ExternalStorefrontEmailInUse = React.lazy(() =>
  import("@internal/consumer/external-storefront-email-in-use").then((m) => ({
    default: m.ExternalStorefrontEmailInUse
  }))
)

/**
 * Whether this URL is carrot-app's redirect for an external-storefront SSO launch refused because
 * the member's email is already on another Carrot account (CAP-370). Keyed on the error code alone:
 * the redirect carries nothing else, and which storefront sent the member is not this page's concern.
 */
export function isExternalStorefrontEmailInUse(search: string): boolean {
  return new URLSearchParams(search).get("errorCode") === CarrotErrorCodes.EXTERNAL_STOREFRONT_EMAIL_IN_USE
}

export function ExternalStorefrontEmailInUsePage(): JSX.Element {
  const intl = useIntl()
  return (
    <>
      <Title title={intl.formatMessage({ defaultMessage: "Let's finish setting up your account" })} />
      <React.Suspense fallback={<LoadingInner />}>
        <ExternalStorefrontEmailInUse />
      </React.Suspense>
    </>
  )
}
